import commonUtil from '../../../utils/commonUtil';
import * as defaultConst from '../../../utils/clientConstant';


import {
  USER_LOGIN,
  USER_LOGIN_SUCCESS,
  USER_LOGIN_FAIL,
  USER_REGISTRATION,
  USER_REGISTRATION_SUCCESS,
  USER_REGISTRATION_FAIL,
  USER_ACTIVE_SESSION,
  USER_ACTIVE_SESSION_SUCCESS,
  USER_ACTIVE_SESSION_FAIL,
  USER_LOGOUT,
  USER_LOGOUT_SUCCESS,
  USER_LOGOUT_FAIL,
} from './actions';

const initialState = {
  loaded: false,
  editing: {},
  saveError: {},
  data: {},
  extraData: {},
};

export default function reducer(state = initialState, action = {}) {
  switch (action.type) {
    case USER_LOGIN:
      return {
        ...state,
        loading: true,
      };
    case USER_LOGIN_SUCCESS:
      if (action.result.profileId && action.result.status.status === defaultConst.constAPISuccess) {
        commonUtil.createCookie('LoginStatus', 'Success', 0.02);
      }
      return {
        ...state,
        loading: false,
        loaded: true,
        data: { actionType: 'login', result: action.result },
        error: null,
        extraData: 'This is extra info..........',
      };
    case USER_LOGIN_FAIL:
      return {
        ...state,
        loading: false,
        loaded: false,
        data: null,
        error: action.error,
      };
    case USER_REGISTRATION:
      return {
        ...state,
        loading: true,
      };
    case USER_REGISTRATION_SUCCESS:
      return {
        ...state,
        loading: false,
        loaded: true,
        data: { actionType: 'registration', result: action.result },
        error: null,
        extraData: 'This is extra info..........',
      };
    case USER_REGISTRATION_FAIL:
      return {
        ...state,
        loading: false,
        loaded: false,
        data: null,
        error: action.error,
      };
    case USER_ACTIVE_SESSION:
      return {
        ...state,
        loading: true,
      };
    case USER_ACTIVE_SESSION_SUCCESS:
      return {
        ...state,
        loading: false,
        loaded: true,
        data: { actionType: 'activeSession', result: action.result },
        error: null,
        extraData: 'This is extra info..........',
      };
    case USER_ACTIVE_SESSION_FAIL:
      return {
        ...state,
        loading: false,
        loaded: false,
        data: null,
        error: action.error,
      };
    case USER_LOGOUT:
      return {
        ...state,
        loading: true,
      };
    case USER_LOGOUT_SUCCESS:
      if (action.result.status.status === defaultConst.constAPISuccess) {
        commonUtil.createCookie('LoginStatus', '', 0.02);
      }
      return {
        ...state,
        loading: false,
        loaded: true,
        data: { actionType: 'logout', result: action.result },
        error: null,
        extraData: 'This is extra info..........',
      };
    case USER_LOGOUT_FAIL:
      return {
        ...state,
        loading: false,
        loaded: false,
        data: null,
        error: action.error,
      };
    default:
      return state;
  }
}
